import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import api from "../../Api";
import { storeToken } from "../../utils/helper";
export const userLogin = createAsyncThunk("userLogin", async (d) => {
  const res = await api.post(`${process.env.REACT_APP_BASE_URL}/auth/login`, {
    email: d.email,
    password: d.password,
  });
  return { data: res.data, remember_me: d.rememberMe };
});

export const userLogout = createAsyncThunk("userLogout", async (d) => {
  try {
    const res = await api.get(
      `${process.env.REACT_APP_BASE_URL}/auth/user/logout`
    );
    return {};
  } catch (error) {
    throw error;
  }
});
export const getConfig = createAsyncThunk("getConfig", async (d) => {
  try {
    const res = await api.get(`${process.env.REACT_APP_BASE_URL}/auth/readenv`);
    return { data: res.data.results };
  } catch (error) {
    throw error;
  }
});
export const getUser = createAsyncThunk("getUser", async (d) => {
  try {
    const res = await api.get(
      `${process.env.REACT_APP_BASE_URL}/auth/user/${d}`
    );
    return { data: res.data.results };
  } catch (error) {
    throw error;
  }
});
export const updateUser = createAsyncThunk("updateUser", async (d) => {
  try {
     const res = await api.put(
      `${process.env.REACT_APP_BASE_URL}/auth/update/${d.id}`,{
        user_name:d.username,phone:d.phone
      }
    );
   
     return { data: res.data.results };
  } catch (error) {
    throw error;
  }
});
export const changePassword = createAsyncThunk("changePassword", async (d) => {
  try {
    const res = await api.put(
      `${process.env.REACT_APP_BASE_URL}/auth/changepassword/${d.id}`,
      {
        newPassword: d.newPassword,
      }
    );
    return {};
  } catch (error) {
    throw error;
  }
});

let localData =
  JSON.parse(localStorage.getItem("user")) ||
  JSON.parse(sessionStorage.getItem("user"));

const authSlice = createSlice({
  name: "auth",
  initialState: {
    isAuthenticated: localData ? true : false,
    data: localData,
    user: {},
    api_Config: {},
    isLoading: false,
    isError: false,
    isSuccess: false,
    isUpdateSuccess: false,
    errMsg: "",
  },
  reducers: {
    reset: (state) => {
      state.isError = false;
      state.errMsg = "";
      state.isSuccess = false;
      state.isUpdateSuccess = false;
    },
  },

  extraReducers: (builder) => {
    builder.addCase(userLogin.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(userLogin.fulfilled, (state, { payload }) => {
      state.isLoading = false;

      if (payload.data.error) {
        state.isError = true;
        state.errMsg = payload.data.message;
      } else {
        state.isAuthenticated = true;
        storeToken(payload.data.access_token);
        api.defaults.headers.common[
          "Authorization"
        ] = `Bearer ${payload.data.access_token}`;
        
        if (payload.remember_me) {
          localStorage.setItem("user", JSON.stringify(payload.data));
        } else {
          sessionStorage.setItem("user", JSON.stringify(payload.data));
        }
        window.location.replace("/");
        window.location.reload();
      }
    });
    builder.addCase(userLogin.rejected, (state, action) => {
      state.isLoading = false;
      state.isError = true;
      state.errMsg = "Error Occured";
    });

    builder.addCase(getConfig.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(getConfig.fulfilled, (state, action) => {
      state.isLoading = false;
      state.api_Config = action.payload.data;
    });
    builder.addCase(getConfig.rejected, (state, action) => {
      state.isLoading = false;
      state.isError = true;
      state.errMsg = "Error Occurred";
    });

    builder.addCase(changePassword.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(changePassword.fulfilled, (state, action) => {
      state.isLoading = false;
      state.isSuccess = true;
    });
    builder.addCase(changePassword.rejected, (state, action) => {
      state.isLoading = false;
      state.isError = true;
      state.errMsg = "Error Occurred";
    });

    builder.addCase(getUser.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(getUser.fulfilled, (state, action) => {
      state.isLoading = false;
      state.user = action.payload.data;
    });
    builder.addCase(getUser.rejected, (state, action) => {
      state.isLoading = false;
      state.isError = true;
      state.errMsg = "Error Occurred";
    });

    builder.addCase(updateUser.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(updateUser.fulfilled, (state, action) => {
      state.isLoading = false;
      state.isUpdateSuccess = true;
    });
    builder.addCase(updateUser.rejected, (state, action) => {
      state.isLoading = false;
      state.isError = true;
      state.errMsg = "Error Occurred";
    });

    builder.addCase(userLogout.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(userLogout.fulfilled, (state, action) => {
      state.isLoading = false;
      state.isAuthenticated = false;
      localStorage.clear();
      sessionStorage.clear();
    });
    builder.addCase(userLogout.rejected, (state, action) => {
      state.isLoading = false;
      state.isError = true;
      state.errMsg = "Error Occurred";
    });
  },
});

export const { login, logout, reset } = authSlice.actions;
export default authSlice.reducer;
